// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type PageEventRead,
  PageEventReadFromJSON,
  PageEventReadToJSON,
} from "../models/PageEventRead";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface EventListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: EventListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   * Filter by project
   */
  projectId?: string | null;
  /**
   * Filter by user
   */
  userId?: string | null;
}

/**
 *
 */
export class EventsApi extends runtime.BaseAPI {
  /**
   * Creates request options for eventList without sending the request
   */
  async eventListRequestOpts(requestParameters: EventListRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling eventList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["projectId"] != null) {
      queryParameters["project_id"] = requestParameters["projectId"];
    }

    if (requestParameters["userId"] != null) {
      queryParameters["user_id"] = requestParameters["userId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/events`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a list of events for a specific tenant. When filtering by user_id, you only need \'tenant_retrieve\'. When filtering by project_id, you need \'project_read\'. Otherwise, you need \'tenant_manage\'.
   * list events
   */
  async eventListRaw(
    requestParameters: EventListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageEventRead>> {
    const requestOptions = await this.eventListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PageEventReadFromJSON(jsonValue));
  }

  /**
   * Return a list of events for a specific tenant. When filtering by user_id, you only need \'tenant_retrieve\'. When filtering by project_id, you need \'project_read\'. Otherwise, you need \'tenant_manage\'.
   * list events
   */
  async eventList(
    requestParameters: EventListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageEventRead> {
    const response = await this.eventListRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const EventListOrderByEnum = {
  CreatedAt: "created_at",
  CreatedAt2: "-created_at",
} as const;
export type EventListOrderByEnum = (typeof EventListOrderByEnum)[keyof typeof EventListOrderByEnum];
